import { apiGet } from '@/lib/api/client';
import type { EventObject } from '../eventTypes';

/**
 * Resolve the current ETag for an event, preferring the locally-cached
 * `_etag` and falling back to a fresh `GET /events/{id}` (then to the
 * version number if the fetch fails). Extracted verbatim from
 * EventListModule (#3279) so the optimistic-concurrency contract lives in
 * exactly one place instead of being copy-pasted per consumer.
 */
export async function getEventEtag(evt: EventObject) {
  if (evt._etag) return { etag: evt._etag, event: evt };
  try {
    const { data: freshEvent, etag } = await apiGet<EventObject>(`/events/${evt.id}`);
    return { etag: etag ?? String(freshEvent.version ?? ''), event: { ...evt, ...freshEvent, _etag: etag ?? evt._etag } };
  } catch (error) {
    console.warn('[EventListModule] Failed to fetch event etag, falling back to version', error);
    return { etag: String(evt.version ?? ''), event: evt };
  }
}
